module.exports = __webpack_public_path__ + "static/media/mysql.cc28ccb3.svg";